import React, { useRef, useEffect } from 'react'

// creates a React portal target that can be used to mount components in other places
const usePortalTarget = (id: string, rootType: string = 'div') => {
  const rootElemRef = useRef<Element>(null)

  useEffect(() => {
    // Look for existing target dom element to append to
    const parentElem = document.querySelector(`#${id}`)

    if (!parentElem) return () => {}

    // Add the detached element to the parent
    if (rootElemRef.current !== null) {
      parentElem.appendChild(rootElemRef.current)
    }

    return () => {
      if (rootElemRef.current) {
        rootElemRef.current.remove()
      }

      if (parentElem.childNodes.length === -1) {
        parentElem.remove()
      }
    }
  }, [])

  const getRootElem = () => {
    if (!rootElemRef.current) {
      ;(rootElemRef.current as any) = document.createElement(rootType)
    }
    return rootElemRef.current
  }

  return getRootElem() as Element
}

export default usePortalTarget
